// src/hooks/useListingForm.js
import { useState, useCallback } from 'react';

export const useListingForm = (initialState = {}) => {
  const [form, setForm] = useState({
    // Common listing fields
    title: '',
    description: '',
    price: '',
    condition: 'brand_new',
    listing_type: 'product',
    category_id: '',
    subcategory_id: '',
    state_id: '',
    lga_id: '',
    lcda_id: '',
    is_negotiable: false,
    
    // Electronics fields (all categories)
    brand: '',
    model: '',
    storage_capacity: '',
    ram: '',
    screen_size: '',
    processor: '',
    color: '',
    battery_health: '',
    network_type: '',
    operating_system: '',
    includes_accessories: false,
    
    // Additional Electronics fields (from specialized forms)
    sensor_size: '',
    megapixels: '',
    lens_type: '',
    resolution: '',
    cellular_support: '',
    battery_life: '',
    edition: '',
    
    // Services fields
    service_type: 'individual',
    experience_years: '',
    qualification: '',
    service_area: '',
    availability: 'flexible',
    pricing_type: 'fixed',
    hourly_rate: '',
    fixed_price: '',
    provides_equipment: false,
    provides_supplies: false,
    insurance_covered: false,
    
    // Additional Services fields
    specialization: '',
    cleaning_type: '',
    team_size: '',
    cleaning_duration: '',
    service_focus: '',
    session_type: '',
    subject: '',
    educational_level: '',
    
    // Vehicles fields
    vehicle_condition: 'good',
    make: '',
    vehicle_model: '',
    year: '',
    trim: '',
    body_type: '',
    drivetrain: 'front',
    engine_size: '',
    cylinders: '',
    horsepower: '',
    vehicle_color: '',
    interior_color: '',
    seats: '',
    is_registered: false,
    custom_duty_paid: true,
    
    // Additional Vehicles fields
    transmission: '',
    fuel_type: '',
    doors: '',
    mileage: '',
    vehicle_type: '',
    engine_cc: '',
    boat_type: '',
    length: '',
    
    // Properties fields
    property_type: 'apartment',
    bedrooms: '',
    bathrooms: '',
    toilets: '',
    area_size: '',
    area_unit: 'sqm',
    furnishing: 'unfurnished',
    parking_spaces: '',
    floor_number: '',
    total_floors: '',
    property_status: 'used',
    service_charge: '',
    
    // Additional Properties field
    topography: '',
    
    ...initialState
  });

  const updateForm = useCallback((updates) => {
    // console.log('🔄 Updating form with:', updates);
    setForm(prev => ({ ...prev, ...updates }));
  }, []);

  const resetForm = useCallback(() => {
    // console.log('🔄 Resetting form');
    setForm({
      title: '',
      description: '',
      price: '',
      condition: 'brand_new',
      listing_type: 'product',
      category_id: '',
      subcategory_id: '',
      state_id: '',
      lga_id: '',
      lcda_id: '',
      is_negotiable: false,
      
      brand: '',
      model: '',
      storage_capacity: '',
      ram: '',
      screen_size: '',
      processor: '',
      color: '',
      battery_health: '',
      network_type: '',
      operating_system: '',
      includes_accessories: false,
      
      sensor_size: '',
      megapixels: '',
      lens_type: '',
      resolution: '',
      cellular_support: '',
      battery_life: '',
      edition: '',
      
      service_type: 'individual',
      experience_years: '',
      qualification: '',
      service_area: '',
      availability: 'flexible',
      pricing_type: 'fixed',
      hourly_rate: '',
      fixed_price: '',
      provides_equipment: false,
      provides_supplies: false,
      insurance_covered: false,
      
      specialization: '',
      cleaning_type: '',
      team_size: '',
      cleaning_duration: '',
      service_focus: '',
      session_type: '',
      subject: '',
      educational_level: '',
      
      vehicle_condition: 'good',
      make: '',
      vehicle_model: '',
      year: '',
      trim: '',
      body_type: '',
      drivetrain: 'front',
      engine_size: '',
      cylinders: '',
      horsepower: '',
      vehicle_color: '',
      interior_color: '',
      seats: '',
      is_registered: false,
      custom_duty_paid: true,
      
      transmission: '',
      fuel_type: '',
      doors: '',
      mileage: '',
      vehicle_type: '',
      engine_cc: '',
      boat_type: '',
      length: '',
      
      property_type: 'apartment',
      bedrooms: '',
      bathrooms: '',
      toilets: '',
      area_size: '',
      area_unit: 'sqm',
      furnishing: 'unfurnished',
      parking_spaces: '',
      floor_number: '',
      total_floors: '',
      property_status: 'used',
      service_charge: '',
      
      topography: '',
    });
  }, []);

  return { form, updateForm, resetForm };
};